import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import { Redirect } from "react-router-dom";
import {
  matchedOrganizationsSelector,
  organizationsIsLoadingSelector,
} from "../../../selectors";
import { oidcSelector } from "../../../selectors/oidcSelectors";
import { organizationAuthentication } from "../../../actions";
import { userManagerFactory } from "../../../services/oidc/utils/userManager";
import LoginRuleForm from "../components/login-oidc-form/LoginRuleForm";
import LoginOrganizationPage from "./LoginOrganizationPage";
import { PageTitle } from "../../../components/common";

const LoginRulePage = () => {
  const dispatch = useDispatch();
  const oidc = useSelector(oidcSelector);
  const [chooseOrganization, setChooseOrganization] = useState(false);
  const matchedOrganizations = useSelector(matchedOrganizationsSelector);
  const isLoading = useSelector(organizationsIsLoadingSelector);
  const handleSubmit = (data) => {
    dispatch(organizationAuthentication(data));
  };
  const LoginOrganization = (data) => {
    const userManager = userManagerFactory();
    userManager.signinRedirect();
  };
  useEffect(() => {
    if (matchedOrganizations) {
      if (matchedOrganizations.length === 1) {
        const organization = matchedOrganizations[0];
        localStorage.setItem("orgName", organization.name);
        localStorage.setItem("authorityUrl", organization.authorityUrl);
        localStorage.setItem("orgName", organization.name);
        const userManager = userManagerFactory();
        userManager.signinRedirect();
      } else if (matchedOrganizations.length > 1) {
        setChooseOrganization(true);
      }
    }
  }, [matchedOrganizations]);
  return (
    <React.Fragment>
      <PageTitle title="login" className="bg-white page-title-login" />
      {!chooseOrganization &&
        !oidc.isLoadingUser &&
        (!oidc.user || oidc.user.expired) && (
          <Container className="mt-5">
            <Row>
              <Col lg={12}>
                <LoginRuleForm
                  title="Login"
                  handleSubmit={handleSubmit}
                  isLoading={isLoading}
                />
              </Col>
            </Row>
          </Container>
        )}
      {!oidc.isLoadingUser && oidc.user && !oidc.user.expired && (
        <Redirect to="/" />
      )}
      {chooseOrganization && (
        <LoginOrganizationPage
          organizations={matchedOrganizations}
          handleSubmit={LoginOrganization}
          isLoading={isLoading}
        />
      )}
    </React.Fragment>
  );
};
export default LoginRulePage;



// WEBPACK FOOTER //
// ./src/features/login/pages/LoginRulePage.jsx